/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Incode_LabelInputs */



/**
* | output |
* | --- |
* | "Project Incode" |
*
* @param {New_Project_Incode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_incode_label = /** @type {((inputs?: New_Project_Incode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Incode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incode du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt Incode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto Incode")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект Incode")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto Incode")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目编码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト・インコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट इनकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto Incode")
	return /** @type {LocalizedString} */ ("Project Incode")
});